// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__QX2nV","header":"MergedInvoice_header__18T39"};